import React from "react";

export default function ExplainerSection() {
  return (
    <section className="Section">
      <h2>What&rsquo;s a UPRN, anyway?</h2>
      <div className="Explainer-grid">
        <div className="Explainer-card">
          <h3>One number per place</h3>
          <p>
            A Unique Property Reference Number is the unique identifier
            Ordnance Survey assigns to every addressable location in
            Great Britain. It never changes, even if the address does —
            making it the most reliable way to refer to a property.
          </p>
        </div>
        <div className="Explainer-card">
          <h3>Blocks and their flats, linked</h3>
          <p>
            A block of flats gets its own &ldquo;parent&rdquo; UPRN, and every flat
            inside it gets a child UPRN linked back to the building. Search
            any flat here and we&rsquo;ll show you its block and every other
            property that shares it.
          </p>
        </div>
        <div className="Explainer-card">
          <h3>Why it matters</h3>
          <p>
            Councils, emergency services, utilities, insurers and property
            managers all use UPRNs to talk about the same building without
            ambiguity. If you manage or live in a block, its UPRN is the key
            to joining those records together.
          </p>
        </div>
      </div>
    </section>
  );
}
